/**
 * Color palette and other application colors.
 * 
 * This object defines a set of color palettes and other colors used throughout the application.
 * Each color palette uses a Material Design naming convention with shades from 50 (lightest) to 900 (darkest).
 */
const Colors = {
  //Palette colors
  palette: {
    primary: {
      50: '#E3F8FC',
      100: '#C7F2F8',
      200: '#91E5F2',
      300: '#5ED8EB',  // Light Color (theme.palette.primary.light)
      400: '#2ECCE4',
      500: '#00C1DE',  // Main color (theme.palette.primary.main)
      600: '#009AB2',
      700: '#007485',  // Dark Color (theme.palette.primary.dark)
      800: '#004D59',
      900: '#00272C'
    },
    secondary: {
      50: '#F5F7F7',
      100: '#ECEEEE',
      200: '#D9DDDE',
      300: '#C6CDCD',
      400: '#B3BCBD',
      500: '#A0ABAC',
      600: '#7D8C8D',
      700: '#5D696A',
      800: '#3E4647',
      900: '#1F2323'
    },
    success: {
      50: '#F3FBE2',
      100: '#E7F7C5',
      200: '#D0EF8F',
      300: '#BBE75C',
      400: '#A6DE2C',
      500: '#93D500',
      600: '#76AA00',
      700: '#588000',
      800: '#3B5500',
      900: '#1D2B00'
    },
    warning: {
      50: '#FFF2E4',
      100: '#FFE5CA',
      200: '#FFCB95',
      300: '#FFB060',
      400: '#FF962B',
      500: '#F57C00',
      600: '#B85D00',
      700: '#934A00',
      800: '#623200',
      900: '#311900'
    },
    error: {
      50: '#FFE5F7',
      100: '#FFCBF0',
      200: '#FF98E1',
      300: '#FF64D2',
      400: '#FF31C2',
      500: '#FC00B2',
      600: '#CA008E',
      700: '#97006B',
      800: '#650047',
      900: '#320024'
    }
  },
  darkModeShades: {
    50: '#3F3F51',
    100: '#3D3D4F',
    200: '#3B3B4D',
    300: '#363649',
    400: '#343447',
    500: '#303043',
    600: '#2D2D41',
    700: '#2B2B3E',
    800: '#26263A',
    900: '#1B1B30'
  },
  transparent: 'rgba(0, 0, 0, 0)',
  white: '#FFFFFF',
  shadow: 'rgba(0, 0, 0, 0.08)',
  semiTransparent: '#00000033'
};

export default Colors;
